module.exports = __webpack_public_path__ + "static/media/accounting-about-us.b9f145ab.jpg";